import update from 'immutability-helper';
import { SET_NEW_SHOPPINGCART } from './shoppingCartReducer.js';
import {LEO_THEME} from "../dev";

export const initialState = {
	accessCodesEnabled: false,
	accessCodesMandatory: false,
	plUuidCodeMap: {},
};

// ------------------------------------
// Constants
// ------------------------------------
export const SET_ACCESS_CODES_ENABLED = 'ACCESS_CODES/SET_ACCESS_CODES_ENABLED';
export const SET_ACCESS_CODES_MANDATORY = 'ACCESS_CODES/SET_ACCESS_CODES_OPTIONAL';
export const SET_PRICELEVELUUIDCODEMAP = 'ACCESS_CODES/SET_PRICELEVELUUIDCODEMAP';

export function setAccessCodesEnabled(accessCodesEnabled) {
	return {
		type: SET_ACCESS_CODES_ENABLED,
		accessCodesEnabled,
	};
}

export function setAccessCodesMandatory(accessCodesMandatory) {
	return {
		type: SET_ACCESS_CODES_MANDATORY,
		accessCodesMandatory,
	};
}

export function setPlUuidCodeMap(plUuidCodeMap) {
	return {
		type: SET_PRICELEVELUUIDCODEMAP,
		plUuidCodeMap,
	};
}


// -------------------
// Action Creators
// -------------------
export function loadAccessCodesConfig() {
	const accessCodesDisabledValue = (LEO_THEME.modules['access-codes'] && LEO_THEME.modules['access-codes']['access-codes-disabled'])
		? LEO_THEME.modules['access-codes']['access-codes-disabled'] : '';
	const accessCodesEnabled = !(accessCodesDisabledValue === 'true');
	return (dispatch) => {
		if (!accessCodesEnabled) {
			return Promise.resolve();
		}
		const accessCodesMandatoryValue = (LEO_THEME.modules['access-codes'] && LEO_THEME.modules['access-codes']['access-codes-mandatory'])
			? LEO_THEME.modules['access-codes']['access-codes-mandatory'] : '';
		const accessCodesMandatory = accessCodesMandatoryValue === 'true';
		dispatch(setAccessCodesMandatory(accessCodesMandatory));
		return dispatch(setAccessCodesEnabled(accessCodesEnabled));
	};
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
	[SET_ACCESS_CODES_ENABLED]: (state, action) => update(state,	{
		accessCodesEnabled: { $set: action.accessCodesEnabled },
	}),
	[SET_ACCESS_CODES_MANDATORY]: (state, action) => update(state,	{
		accessCodesMandatory: { $set: action.accessCodesMandatory },
	}),
	[SET_PRICELEVELUUIDCODEMAP]: (state, action) => update(state,	{
		plUuidCodeMap: { $set: action.plUuidCodeMap },
	}),
	// basically resetting the codes if "session has ended" (new Shoppingcart)
	[SET_NEW_SHOPPINGCART]: (state) => update(state,	{
		plUuidCodeMap: { $set: initialState.plUuidCodeMap },
	}),
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function reducerFunction(state = initialState, action) {
	const handler = ACTION_HANDLERS[action.type];
	return handler ? handler(state, action) : state;
}
